import './base';
import './utils';
import './components';

$(document).foundation();
